// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--VN8fX","root":"index-module--root--2-oeC","main":"index-module--main--2bgHV"};